<template>
  <router-link v-bind="route">{{ label }}</router-link>
</template>

<script>
  import api from '@/api'

  export default {
    name: 'RouteLabelConverter',
    props: {
      request: {
        type: Object,
        required: true
      },
      call: {
        type: String,
        required: true,
      },
      route: {
        type: Object,
        required: true,
      },
      handler: {
        type: Function,
        required: true,
      },
      placeholder: {
        required: false
      }
    },
    data() {
      return {
        label: this.placeholder,
      }
    },
    created() {
      api[this.call](this.request, data => this.label = this.handler(data));
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/RouteLabelConverter.vue